import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type PresetCategory = 'video' | 'image' | 'motion';

export interface ContentPreset {
  id: string;
  name: string;
  category: PresetCategory;
  tagline: string;
  description: string;
  effect_chips: string[];
  target_avg_scene_secs: number;
  default_visual_model: string | null;
  default_visual_style: string | null;
  default_voice: string | null;
  default_style: string | null;
  default_direction: string | null;
  preview_url: string | null;
  preview_type: 'video' | 'image';
  expected_min_credits_per_scene: number;
  expected_max_credits_per_scene: number;
}

interface PresetCatalogResponse {
  presets: ContentPreset[];
}

export function usePresets() {
  return useQuery<PresetCatalogResponse>({
    queryKey: ['content-presets'],
    queryFn: async () => {
      const response = await api.get('/presets');
      return response.data;
    },
    staleTime: Infinity,
    retry: 2,
  });
}
